






import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component({})
export default class IconButton extends Vue {
  @Prop({})
  private img!: string;
  @Prop({})
  private name!: string;
  @Prop({default: false})
  private disabled!: boolean;

  private icon(): string {
    return require('@/assets/icon/' + this.img);
  }

  @Emit('click')
  private doClick(): void {
    return;
  }
}
